var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLetterPaper = function SvgLetterPaper(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "url(#letter-paper_svg__a)",
    rx: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.058 23.23H11.212q-.589 0-1.016-.426t-.427-1.015V6.942q0-.588.427-1.015t1.016-.427h7.584q.302 0 .574.12t.463.31l4.236 4.237q.19.19.31.463t.121.574v10.585q0 .588-.427 1.015t-1.015.427m.307-12.136h-3.598q-.391 0-.667-.27-.275-.269-.275-.662V6.635h-7.613q-.116 0-.212.096t-.096.211V21.79q0 .115.096.211t.212.096h11.846q.115 0 .211-.096t.096-.211zM7.942 26.5q-.588 0-1.015-.427T6.5 25.058V11.352q0-.242.164-.405.164-.162.408-.162t.403.162.16.405v13.706q0 .115.096.211t.211.096h10.681q.242 0 .405.165.162.164.162.407 0 .244-.163.403t-.404.16zm2.962-19.865v4.46zv15.461z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "letter-paper_svg__a",
    x1: 3,
    x2: 36,
    y1: 30,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F2E55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4277FC"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLetterPaper);
export default ForwardRef;